import {
  NavrhUzneseniaVlady,
  NavrhUzneseniaVladyApi,
  NavrhUzneseniaVladyBod as NavrhUzneseniaVladyBodDto,
  NavrhUzneseniaVladyCast as NavrhUzneseniaVladyCastDto,
} from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import Uuid from '../../../model/Uuid';
import {
  NavrhUzneseniaVladyFormData,
} from '../../../model/sprievodnyDokument/navrhUzneseniaVlady/NavrhUzneseniaVladyFormData';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import convertIndexToChar from '../../../function/convertIndexToChar';
import {
  NavrhUzneseniaVladyBod,
} from '../../../model/sprievodnyDokument/navrhUzneseniaVlady/NavrhUzneseniaVladyBod';
import {
  NavrhUzneseniaVladyCast,
} from '../../../model/sprievodnyDokument/navrhUzneseniaVlady/NavrhUzneseniaVladyCast';

const client = new NavrhUzneseniaVladyApi(apiConfiguration(evidenciaPrefixPath));

function mapBod(bod: NavrhUzneseniaVladyBod, cast: string, index: number): NavrhUzneseniaVladyBodDto {
  const bodIndex = index + 1;
  return {
    bod: `${cast}.${bodIndex}`,
    termin: bod.termin,
    text: bod.text,
    zodpovednaOsoba: bod.zodpovednaOsoba,
  };
}
function mapCast(cast: NavrhUzneseniaVladyCast, castIndex: number): NavrhUzneseniaVladyCastDto {
  const castNazov = convertIndexToChar(castIndex);
  return {
    cast: castNazov,
    zamerCasti: cast.zamerCasti,
    bodList: cast.bodList.map((value, index) => mapBod(value, castNazov, index)),
  };
}

function map(formData: NavrhUzneseniaVladyFormData): NavrhUzneseniaVlady {
  return {
    isUznesenie: formData.isUznesenie,
    nazovMaterialu: formData.nazovMaterialu,
    cisloMaterialu: formData.cisloMaterialu,
    predkladatel: formData.predkladatel,
    castList: formData.castList.map((value, index) => mapCast(value, index)),
    naVedomie: formData.naVedomie,
    vykonaju: formData.vykonaju,
  };
}

export const createNavrhUzneseniaVladyClient = async (
  legMaterialUuid: Uuid,
  formData: NavrhUzneseniaVladyFormData,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.createNavrhUzneseniaVlady(legMaterialUuid, map(formData), stadiumUuid, headers);

  return {
    responseCode: status,
  };
};

export const updateNavrhUzneseniaVladyClient = async (
  legMaterialUuid: Uuid,
  formData: NavrhUzneseniaVladyFormData,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.editNavrhUzneseniaVlady(legMaterialUuid, map(formData), stadiumUuid, headers);

  return {
    responseCode: status,
  };
};
